import React, { FC, useState } from 'react'
import { FacetsConnector, FacetsConnectorProps } from 'connectors/Facets'
import CheckboxListFacet from '../components/CheckboxListFacet'
import { BaseFacetProps } from '../types'

type ArtistCountryFacetProps = BaseFacetProps & FacetsConnectorProps

const ArtistCountryFacet: FC<ArtistCountryFacetProps> = ({
  baseUrl,
  nextAppRoute,
  getFacetNameAttributesList,
}) => {
  const initialCountriesArray = getFacetNameAttributesList('country')
  const [countriesList, setCountriesList] = useState(initialCountriesArray)

  const handleFilterFacetTextCallback = (textQuery: string) => {
    const filteredCountriesArray = initialCountriesArray.filter((str) =>
      str?.toLocaleLowerCase()?.includes(textQuery?.toLocaleLowerCase())
    )
    setCountriesList(filteredCountriesArray)
  }

  return (
    <CheckboxListFacet
      facetName='country'
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
      filterTextPlaceholder='Search Country'
      attributesList={countriesList}
      onFilterFacetTextCallback={handleFilterFacetTextCallback}
    />
  )
}

export default FacetsConnector(ArtistCountryFacet)
